<script>
    import { page } from '$app/stores';
    import FaqSection from "$lib/components/FAQSection.svelte";
    import SEOHead from '$lib/components/SEOHead.svelte';
    import { t } from '$lib/i18n.js';
    import { generateStructuredData, getSiteAggregateRating, seoConfig } from '$lib/seo.js';
    import Advantages from "./sections/advantages/advantages.svelte";
    import Earn from "./sections/earn/earn.svelte";
    import HowToPublish from "./sections/how-to-publish/how-to-publish.svelte";
    import Metrics from "./sections/metrics/metrics.svelte";
    import Protections from "./sections/protections/protections.svelte";
    import Rent from './sections/rent/rent.svelte';
    import RentProfessional from './sections/rent/rent_professional.svelte';
    import SuperOwner from "./sections/super-owner/super-owner.svelte";
    import WayOfSharing from "./sections/whay-of-sharing/way-of-sharing.svelte";

    $: lang = $page.params.lang;
	$: aggregateRating = getSiteAggregateRating();
	$: structuredData = [
		generateStructuredData('Organization', {}, lang),
		generateStructuredData('WebSite', {}, lang),
		generateStructuredData('Service', {
			name: `Auting - ${$t('routes.owner.title')}`,
			description: $t('routes.owner.description') ?? seoConfig.businessDescription[lang],
			url: `https://auting.it/${lang === 'en' ? '' : lang}/owner`,
			...(aggregateRating ? { aggregateRating } : {})
		}, lang),
		generateStructuredData('WebPage', {
			title: $t('routes.owner.title'),
			description: $t('routes.owner.description') ?? seoConfig.defaultDescription[lang],
			url: `https://auting.it/${lang === 'en' ? '' : lang}`
		}, lang)
	];
</script>

<SEOHead 
	title="{$t('routes.owner.title')} - Auting"
	description={$t('routes.owner.description') ?? seoConfig.defaultDescription[lang]}
	keywords={seoConfig.defaultKeywords[lang]}
	structuredData={structuredData}
	pageName="owner"
/>

<Earn />
<Metrics />
<HowToPublish />
<Advantages />
<WayOfSharing />
<Protections />
<SuperOwner />
<!-- <Rent /> -->
<!-- <RentProfessional /> -->
<FaqSection page='owner'/>

<style></style>